package amazon.lastmile.inject

import app.nestbridge.feature.invitations.presentation.InvitationQrScanPresenterFactory
import com.slack.circuit.runtime.presenter.Presenter
import me.tatarka.inject.annotations.IntoSet
import me.tatarka.inject.annotations.Provides
import software.amazon.lastmile.kotlin.inject.anvil.`internal`.Origin

@Origin(value = InvitationQrScanPresenterFactory::class)
public interface AppNestbridgeFeatureInvitationsPresentationInvitationQrScanPresenterFactory {
  @Provides
  @IntoSet
  public fun provideInvitationQrScanPresenterFactoryFactoryMultibinding(invitationQrScanPresenterFactory: InvitationQrScanPresenterFactory): Presenter.Factory = invitationQrScanPresenterFactory
}
